export default __webpack_public_path__ + "static/media/rock-hector.bc155de9.png";